// extracted by mini-css-extract-plugin
export default {"title":"styles_title__dPinp","subtitle":"styles_subtitle__okKAg","titleWrapper":"styles_titleWrapper__t4vzG"};